import { createFileRoute } from "@tanstack/react-router";
import UkPricing from "@/pages/UkPricing";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/pricing/")({
  head: () => routeHead("/uk/pricing/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkPricing />
  );
}
